import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PronounceButton from "@/components/PronounceButton";
import { ArrowLeft, Flame } from "lucide-react";

export default function SlangDetail() {
  const { id } = useParams();
  const [slang, setSlang] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/slang/${id}`);
        setSlang(data);
      } catch (e) {
        setError("Slang not found.");
      }
    })();
  }, [id]);

  if (error) return <div className="max-w-3xl mx-auto p-8 font-display text-3xl">{error}</div>;
  if (!slang) return <div className="max-w-3xl mx-auto p-8 font-mono-tag uppercase">loading...</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-10">
      <Link data-testid="back-to-list-link" to="/" className="inline-flex items-center gap-2 font-mono-tag text-xs uppercase brutal-sm bg-white px-3 py-1.5 brutal-hover mb-6">
        <ArrowLeft className="h-3 w-3" strokeWidth={3} /> back
      </Link>

      <div className="bg-lime brutal p-8 sm:p-12">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <span className="font-mono-tag text-xs uppercase bg-white brutal-sm px-2 py-1 inline-block mb-3">{slang.category}</span>
            {slang.trending && (
              <span data-testid="trending-badge-detail" className="ml-2 bg-hot text-white brutal-sm px-2 py-1 font-mono-tag text-[10px] uppercase inline-flex items-center gap-1">
                <Flame className="h-3 w-3" strokeWidth={3} /> Trending
              </span>
            )}
            <h1 data-testid="slang-word-heading" className="font-display text-6xl sm:text-8xl leading-[0.85] tracking-tighter">{slang.word}</h1>
          </div>
          <PronounceButton text={slang.word} testId="pronounce-detail" size="lg" />
        </div>

        <div className="mt-8">
          <p className="font-mono-tag text-[10px] uppercase mb-1">meaning</p>
          <p data-testid="slang-meaning" className="text-lg sm:text-xl leading-snug">{slang.meaning}</p>
        </div>

        {slang.example && (
          <div className="mt-6 bg-white brutal-sm p-5">
            <p className="font-mono-tag text-[10px] uppercase mb-1">in the wild</p>
            <p data-testid="slang-example" className="font-hand text-2xl sm:text-3xl leading-tight">"{slang.example}"</p>
          </div>
        )}

        <div className="mt-6 flex items-center justify-between flex-wrap gap-2">
          <span className="font-mono-tag text-[10px] uppercase">added by {slang.submitted_by || "system"}</span>
          <button
            data-testid="pronounce-large-btn"
            onClick={() => {
              const u = new SpeechSynthesisUtterance(`${slang.word}. ${slang.meaning}. Example: ${slang.example}`);
              u.rate = 0.92; u.lang = "en-US"; window.speechSynthesis.cancel(); window.speechSynthesis.speak(u);
            }}
            className="font-display uppercase text-sm bg-hot text-white px-4 py-2 brutal-sm brutal-hover brutal-active"
          >
            Read whole entry aloud
          </button>
        </div>
      </div>
    </div>
  );
}
